export const stringFormat = {
  verifyExistNameInArray: (
    list: Array<any>,
    name: string,
    id?: number | undefined,
  ): boolean => {
    let finder: any = null;
    if (id && id > 0) {
      finder = list.find(
        (element: any) =>
          element.name.replace(/\s/g, "").toLowerCase() ===
            name.replace(/\s/g, "").toLowerCase() && element.id !== id,
      );
    } else {
      finder = list.find(
        (element: any) =>
          element.name.replace(/\s/g, "").toLowerCase() ===
          name.replace(/\s/g, "").toLowerCase(),
      );
    }

    if (finder) {
      return true;
    }
    return false;
  },

  isVisuallyEmpty: (text?: string | null) => {
    if (!text) return true;
    const cleaned = text.replace(/(&nbsp;|\u00a0|\s)/g, "");
    return cleaned === "";
  },

  isEmptyOrSpaces: (str: string) => {
    return str === null || str.match(/^ *$/) !== null;
  },
  /**
   * Checks if the provided password is strong.
   * A strong password must be at least 8 characters long and include at least one lowercase letter, one uppercase letter, one digit, and one special character.
   * @param {string} password - The password to be checked.
   * @returns {[boolean, string]} A tuple containing a boolean value indicating whether the password is strong and an explanatory message.
   */
  isStrongPassword: (password: string): [boolean, string] => {
    // Check if password is at least 8 characters long
    if (password.length < 8) {
      return [false, "weak"];
    }

    // Check if password contains at least one  lowercase letter, one uppercase letter, one digit, and one special character
    const lowercaseRegex = /[a-z]/;
    const uppercaseRegex = /[A-Z]/;
    const digitRegex = /[0-9]/;
    const specialCharRegex = /[!@#$%^&*()\-_=+[\]{};':"\\|,.<>/?]/;

    if (
      !lowercaseRegex.test(password) ||
      !uppercaseRegex.test(password) ||
      !digitRegex.test(password) ||
      !specialCharRegex.test(password)
    ) {
      return [false, "medium"];
    }
    // Password meets all criteria for a strong password
    return [true, "strong"];
  },
};
